import { Capacitor } from "@capacitor/core";

export const useMobileApp = () => Capacitor.getPlatform() !== 'web'